import * as server from "@/utils/http"

export const _page = params => server.get("/leave-log/page", params);

